import { render, staticRenderFns, recyclableRender, components } from "./consumptionDetails.vue?vue&type=template&id=e7356a34&scoped=true&"
var renderjs
import script from "./consumptionDetails.vue?vue&type=script&lang=js&"
export * from "./consumptionDetails.vue?vue&type=script&lang=js&"
import style0 from "./consumptionDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./consumptionDetails.vue?vue&type=style&index=1&id=e7356a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7356a34",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/consumptionDetails/consumptionDetails.vue"
export default component.exports